(function () {
  var popup = document.getElementById('DuoriExitQuizPopup');
  if (!popup) return;

  var storageKeys = {
    shown: 'duori_exit_quiz_redesign_shown',
    captured: 'duori_email_captured',
    dismissedUntil: 'duori_exit_quiz_redesign_dismissed_until',
    visits: 'duori_visits',
    pages: 'duori_pages',
    lastVisit: 'duori_last_visit'
  };
  var goalLabels = {
    weight_loss: 'Weight Loss',
    better_sleep: 'Better Sleep',
    debloat: 'Debloat',
    mood_energy: 'Mood & Energy',
    just_curious: "I'm Just Curious"
  };
  var selectedGoal = null;
  var shown = false;
  var lastFocused = null;
  var closeTimer = null;
  var suppressUntil = 0;
  var forcePopup = /(?:\?|&)duori_popup_test=(?:1|true)(?:&|$)/.test(window.location.search);
  var popupEligibleAt = 0;
  var maxScrollY = window.scrollY || 0;
  var lastScrollY = window.scrollY || 0;
  var lastScrollAt = Date.now();
  var interactionCount = 0;
  var meaningfulScrollReached = false;
  var hasMeaningfulEngagement = false;

  var $ = function (selector) {
    return popup.querySelector(selector);
  };
  var $$ = function (selector) {
    return Array.prototype.slice.call(popup.querySelectorAll(selector));
  };

  function getNumber(storage, key) {
    return parseInt(storage.getItem(key) || '0', 10);
  }

  function updateVisitorSegment() {
    var visits = getNumber(localStorage, storageKeys.visits) + 1;
    var pagesViewed = getNumber(sessionStorage, storageKeys.pages) + 1;
    var segment = 'new';

    localStorage.setItem(storageKeys.visits, visits);
    localStorage.setItem(storageKeys.lastVisit, Date.now());
    sessionStorage.setItem(storageKeys.pages, pagesViewed);

    if (visits >= 3 || pagesViewed >= 3) {
      segment = 'high-intent';
    } else if (visits >= 2) {
      segment = 'returning';
    }

    window.duoriSegment = window.duoriSegment || segment;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'visitor_segment',
      visitor_segment: window.duoriSegment,
      visit_count: visits,
      pages_this_session: pagesViewed
    });
  }

  function setActiveStep(stepName) {
    $$('.duori-exit-quiz-popup__step').forEach(function (step) {
      step.classList.toggle('is-active', step.getAttribute('data-step') === stepName);
    });
  }

  function isCartFlowActive() {
    return !!document.querySelector('cart-drawer[open], cart-drawer[active], pdp-bundle-selector .btn--loading');
  }

  function shouldSuppressPopup() {
    return !forcePopup && (Date.now() < suppressUntil || isCartFlowActive());
  }

  function isFrequencyCapped() {
    return !forcePopup && Date.now() < getNumber(localStorage, storageKeys.dismissedUntil);
  }

  function markEngagement() {
    interactionCount += 1;
    if (interactionCount >= 2 || meaningfulScrollReached) {
      hasMeaningfulEngagement = true;
    }
  }

  function unlockBodyIfPopupClosed() {
    if (popup.classList.contains('is-active')) return;
    if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
  }

  function suppressPopup(duration) {
    suppressUntil = Math.max(suppressUntil, Date.now() + (duration || 20000));
    if (popup.classList.contains('is-active')) {
      closePopup({ persistDismissal: false });
      return;
    }
    unlockBodyIfPopupClosed();
  }

  function canShowPopup() {
    if (shown) return false;
    if (shouldSuppressPopup()) return false;
    if (isFrequencyCapped()) return false;
    if (!forcePopup && (sessionStorage.getItem(storageKeys.shown) || localStorage.getItem(storageKeys.captured))) return false;
    if (!forcePopup && Date.now() < popupEligibleAt) return false;
    if (!forcePopup && !hasMeaningfulEngagement) return false;
    return true;
  }

  function showPopup(trigger) {
    if (!canShowPopup()) return;
    if (shown) return;

    shown = true;
    lastFocused = document.activeElement;
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!forcePopup) sessionStorage.setItem(storageKeys.shown, '1');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'exit_intent_shown',
      visitor_segment: window.duoriSegment || 'new',
      exit_trigger: trigger || 'exit_intent'
    });

    var firstButton = $('.duori-exit-quiz-popup__option');
    if (firstButton) firstButton.focus();
  }

  function closePopup(options) {
    var settings = options || {};

    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.clearTimeout(closeTimer);

    if (settings.persistDismissal !== false && !forcePopup && !localStorage.getItem(storageKeys.captured)) {
      localStorage.setItem(storageKeys.dismissedUntil, String(Date.now() + (7 * 24 * 60 * 60 * 1000)));
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function dismissPopup() {
    closePopup({ persistDismissal: true });
  }

  function selectGoal(button) {
    selectedGoal = button.getAttribute('data-answer');
    window.exitQuizAnswer = selectedGoal;

    $$('.duori-exit-quiz-popup__option').forEach(function (option) {
      option.classList.toggle('is-selected', option === button);
      option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
    });

    var continueButton = $('.duori-exit-quiz-popup__continue');
    if (continueButton) {
      continueButton.disabled = false;
      continueButton.classList.add('is-active');
    }
  }

  function goToEmailStep() {
    if (!selectedGoal) return;

    var label = $('[data-goal-label]');
    if (label) label.textContent = goalLabels[selectedGoal] || 'your goal';
    setActiveStep('email');

    var input = $('.duori-exit-quiz-popup__input');
    if (input) input.focus();
  }

  function pushEmailCaptured(email) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'exit_email_captured',
      email_captured: true,
      quiz_answer: selectedGoal,
      visitor_segment: window.duoriSegment || 'new',
      source: 'exit_intent_popup'
    });

    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['identify', {
        '$email': email,
        'duori_quiz_goal': selectedGoal,
        'visitor_segment': window.duoriSegment || 'new'
      }]);
      window.klaviyo.push(['track', 'Exit Quiz Email Captured', {
        'quiz_answer': selectedGoal,
        'visitor_segment': window.duoriSegment || 'new',
        'source': 'exit_intent_popup'
      }]);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    var input = $('.duori-exit-quiz-popup__input');
    var email = input ? input.value.trim() : '';
    var tag = $('[data-goal-tag]');
    if (!email) return;

    localStorage.setItem(storageKeys.captured, '1');
    pushEmailCaptured(email);

    if (tag) tag.textContent = goalLabels[selectedGoal] || 'Wellness';
    setActiveStep('success');

    closeTimer = window.setTimeout(function () {
      closePopup({ persistDismissal: false });
    }, 8000);
  }

  function copyCode() {
    var button = $('.duori-exit-quiz-popup__copy');
    var code = popup.getAttribute('data-discount-code') || 'WELCOME15';
    var done = function () {
      if (!button) return;
      button.textContent = 'Copied!';
      window.setTimeout(function () {
        button.textContent = 'Copy';
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      done();
    }
  }

  function wireTriggers() {
    var timeout = Math.max(parseInt(popup.getAttribute('data-timeout-ms') || '7000', 10), 15000);
    popupEligibleAt = Date.now() + timeout;

    function showAfterDelayedScroll() {
      if (Date.now() < popupEligibleAt) return;
      if (!meaningfulScrollReached || !hasMeaningfulEngagement) return;
      showPopup('delayed_scroll_engagement');
    }

    if (forcePopup) {
      window.setTimeout(function () {
        hasMeaningfulEngagement = true;
        showPopup('forced_test');
      }, 300);
      return;
    }

    window.addEventListener('scroll', function () {
      var currentY = window.scrollY || 0;
      var upwardDelta = lastScrollY - currentY;
      meaningfulScrollReached = meaningfulScrollReached || currentY >= 600;
      maxScrollY = Math.max(maxScrollY, currentY);
      if (meaningfulScrollReached) hasMeaningfulEngagement = true;

      showAfterDelayedScroll();

      if (
        currentY > 250 &&
        maxScrollY >= 900 &&
        upwardDelta >= 180 &&
        Date.now() >= popupEligibleAt &&
        (Date.now() - lastScrollAt) >= 4000
      ) {
        showPopup('scroll_return_intent');
      }

      lastScrollY = currentY;
      lastScrollAt = Date.now();
    }, { passive: true });

    ['click', 'keydown', 'touchstart'].forEach(function (eventName) {
      document.addEventListener(eventName, markEngagement, { passive: true });
    });

    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.toElement) return;
      if (event.clientY > 16) return;
      showPopup('top_exit_intent');
    });

    window.setTimeout(showAfterDelayedScroll, timeout + 100);
  }

  function wireCommerceGuards() {
    document.addEventListener('product-ajax:added', function () {
      suppressPopup(30000);
    });

    document.addEventListener('cart:updated', function () {
      suppressPopup(30000);
    });

    document.addEventListener('drawer:handleAfterShow', function (event) {
      if (event.target && event.target.matches && event.target.matches('cart-drawer')) {
        suppressPopup(30000);
      }
    });

    document.addEventListener('drawer:handleAfterHide', function (event) {
      if (event.target && event.target.matches && event.target.matches('cart-drawer')) {
        suppressPopup(15000);
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[aria-controls="CartDrawer"]')) {
        suppressPopup(20000);
      }
    }, true);

    window.addEventListener('pageshow', unlockBodyIfPopupClosed);
  }

  function init() {
    updateVisitorSegment();

    var shopButton = $('.duori-exit-quiz-popup__shop');
    var shopUrl = popup.getAttribute('data-shop-url');
    if (shopButton && shopUrl) shopButton.setAttribute('href', shopUrl);

    $$('.duori-exit-quiz-popup__option').forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', function () {
        selectGoal(button);
      });
    });

    var closeButton = $('.duori-exit-quiz-popup__close');
    var skipButton = $('.duori-exit-quiz-popup__skip');
    var continueButton = $('.duori-exit-quiz-popup__continue');
    var form = $('.duori-exit-quiz-popup__form');
    var copyButton = $('.duori-exit-quiz-popup__copy');

    if (closeButton) closeButton.addEventListener('click', dismissPopup);
    if (skipButton) skipButton.addEventListener('click', dismissPopup);
    if (continueButton) continueButton.addEventListener('click', goToEmailStep);
    if (form) form.addEventListener('submit', handleSubmit);
    if (copyButton) copyButton.addEventListener('click', copyCode);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-active')) {
        dismissPopup();
      }
    });

    wireTriggers();
    wireCommerceGuards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
